import { createContext, useContext } from 'react';

import browser from '@openclassrooms/utils/browser';

const roles = { ...browser.window.App?.user?.roles };

const isGranted = (role) => {
  if (roles[role] === undefined) {
    // eslint-disable-next-line no-console
    console.warn(`'${role}' is not a known role.`);
  }
  return Boolean(roles[role]);
};

const isGrantedOneOf = (rolesToFind) => {
  rolesToFind.forEach((role) => {
    if (roles[role] === undefined) {
      // eslint-disable-next-line no-console
      console.warn(`'${role}' is not a known role.`);
    }
  });

  const grantedRoles = Object.keys(roles).filter((role) => roles[role]);
  return grantedRoles.filter((role) => rolesToFind.includes(role)).length >= 1;
};

const defaultContextValue = { isGranted, isGrantedOneOf };
const RolesProviderContext = createContext(defaultContextValue);

function RolesProvider({ children }) {
  return (
    <RolesProviderContext.Provider value={defaultContextValue}>
      {children}
    </RolesProviderContext.Provider>
  );
}

function useRoles() {
  return useContext(RolesProviderContext);
}

export { RolesProvider, useRoles, isGranted, isGrantedOneOf };
